export const formatDateWithNoHours = (date: string): string => {
  try {
    const dateObj = new Date(date).toISOString().split('T')[0];
    return dateObj.split('-').reverse().join('/');
  } catch (error: any) {
    return ""
  }
};